<template>
  <div :class="['custom-overlay', {animate: animate}]" v-show="visible">
    <div class="dialog-card" :class="{center:center}">
      <div v-if="showClose" class="btn-close" @click="$emit('update:visible', false)"><span></span></div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDialog',

  props: {
    visible: Boolean,
    showClose:{
      type:Boolean,
      default:true
    },
    center:{
      type:Boolean,
      default:false
    }

  },

  data () {
    return {
      animate: false
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.animateShow()
      } else {
        this.animate = false
      }
    }
  },

  mounted () {
    if (this.visible) this.animateShow()
  },

  methods: {
    animateShow () {
      setTimeout(() => {
        this.animate = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.8);
  overflow-y: auto;
  opacity: 0;
  transition: all .3s;
  &.animate {
    opacity: 1;
  }
  .dialog-card {
    position: relative;
    width: 325px;
    margin: 1.22rem auto;
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    &.center{
      margin: 3.5rem auto;
    }
    .btn-close {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      padding: 10px;
      span {
        display: block;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        // background: #e5e5e5 url('../assets/icons/icon_close2.png') center center no-repeat;
        background-size: 15px;
      }
    }
  }
}
</style>
